module.exports = __webpack_public_path__ + "static/media/pra-video.2f8b5786.png";